module.exports = __webpack_public_path__ + "static/media/Illustration_point2.78f79aa6.svg";